import React from 'react';
import {
  ShimmerBox,
  ShimmerIcon,
  ShimmerContainerTop,
  ShimmerContainerLeft,
  ShimmerContainerRight,
  PlaceholderLoadingContainer,
} from '@bit/knotchinc.web-react-components.image-card';

const LoadingCardContent = () => (
  <PlaceholderLoadingContainer>
    <ShimmerContainerTop>
      <ShimmerBox width="66px" height="15px" />
    </ShimmerContainerTop>
    <ShimmerContainerLeft>
      <ShimmerIcon width="32px" height="32px" />
      <ShimmerIcon width="32px" height="32px" />
      <ShimmerBox width="200px" height="17px" />
      <ShimmerBox width="200px" height="17px" />
      <ShimmerBox width="125px" height="17px" />
      <ShimmerBox width="50px" height="8px" />
    </ShimmerContainerLeft>
    <ShimmerContainerRight />
  </PlaceholderLoadingContainer>
);

export default LoadingCardContent;
